import axios from "axios"

export async function leadNewUserInfo(email="", name="", mobile, utm="") {
  try {

    const data = {}
    if(email){
      data.email_address = email
    }
    if(name){
      data.full_name = name
    }
    if(mobile){
      data.mobile_number = `+91-${mobile}`
    }
    if(utm.utm_source){
      data.utm_source = utm.utm_source
    }
    if(utm.utm_medium){
      data.utm_medium = utm.utm_medium
    }
    if(utm.utm_campaign){
      data.utm_campaign = utm.utm_campaign
    }
    if(utm.utm_content){
      data.utm_content = utm.utm_content
    }
    if(utm.utm_term){
      data.utm_term = utm.utm_term
    }

    let response;
    // if(`${process.env.COPILOT_ENVIRONMENT_NAME}` === 'prod' ){
    //   response = await axios.post('https://lead.equentis.com/lead', data, {
    //       headers: {
    //           'x-api-key' : 'cwMY6uDzdp4fevoOZ7Pml5yAzaz12OTL2811p96g',
    //           'Content-Type': 'application/json'
    //       }
    //     }
    //   );
    // } else {
      response = await axios.post(`${process.env.REACT_APP_LEAD_API_URL}`, data, {
          headers: {
              'x-api-key': process.env.REACT_APP_LEAD_API_KEY,
              'Content-Type': 'application/json'
          }
        }
      );
    // }


  // TODO: remove true after testing
  
    // if(`${process.env.COPILOT_ENVIRONMENT_NAME}` === 'prod' || true){
    //   response = await axios.post('https://lead.equentis.com/lead', data, {
    //       headers: {
    //           'x-api-key' : 'cwMY6uDzdp4fevoOZ7Pml5yAzaz12OTL2811p96g',
    //           'Content-Type': 'application/json'
    //       }
    //     }
    //   );
    // } 

    if (response.status === 200 || response.status ==='success') {
      console.log('lead-uat gateway response:', response.data);
      
      return response;
    } else {
      const res = {
        status: 404,
        message: `Error lead-uat gateway: ${response}`
      }

      return res;
    }
  } catch (error) {

    const res = {
      status: 404,
      message: `Error on lead-uat gateway: ${error.message}`
    }

    return res;
  }
}